import React from 'react'
import { Stack } from '@mui/material'
import NavMenu from '../navmenu/navmenu'
import { useGlobalState } from '@biolumina/ui/context/globalStateProvider'

export default function DesktopNav() {
  const {
    siteData: { nav },
  } = useGlobalState()

  return (
    <>
      {nav?.length > 0 && (
        <Stack direction="row" justifyContent="space-between" mt={0.5}>
          {nav.map((navItem) => {
            return <NavMenu key={`${navItem.href}-menu`} data={navItem} />
          })}
        </Stack>
      )}
    </>
  )
}
